import { useSelector } from 'react-redux';
import FJConstant from '../../../../constants/FJConstant.js';
import { useCallback } from 'react';
import FJActionObjectErase from '../../../../redux/action/FJActionObjectErase.js';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import {
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
} from '../../../../config/dataConfig/FJGenerateData.js';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput.jsx';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon.js';

const FJTextImageInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const inputImageInfo = useSelector(state => state.objectErase.textEraseInputImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const isSmallComponent = useMemo(() => {
        return !!inputImageInfo;
    }, [inputImageInfo]);

    const _uploadImage = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadTextEraseImageAction(file));
        },
        [dispatch],
    );

    const _openMediaLibrary = useCallback(() => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    }, [dispatch]);

    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    return (
        <FJImageInput
            openMediaLibrary={_openMediaLibrary}
            disabled={taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR}
            uploadImg={_uploadImage}
            uploadImageInfo={inputImageInfo}
            isSmallComponent={isSmallComponent}
            isDraggingFile={isDraggingFile}
            acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
            style={{ height: '80px' }}
            setIsDraggingFile={_setIsDraggingFile}
        />
    );
};

export default FJTextImageInputContainer;
